// extracted by mini-css-extract-plugin
module.exports = {"container":"Certificate_container__PQHsZ","certificate_img":"Certificate_certificate_img__3xvKJ"};